import React, { useId } from 'react';
import { usePos } from '../../pages/POS/PosContext';

export function CustomerFields({ forceShow }: { forceShow?: boolean }) {
  const { isTakeawayMode, orderCustomer, setOrderCustomer } = usePos();
  const nameId = useId();
  const phoneId = useId();

  if (!isTakeawayMode && !forceShow) {
    return null;
  }

  return (
    <div className="mt-3 space-y-3" aria-live="polite">
      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted" htmlFor={nameId}>
          Nombre del cliente
        </label>
        <input
          id={nameId}
          type="text"
          className="input input-bordered"
          placeholder="Ej. Ana Pérez"
          value={orderCustomer.customerName}
          onChange={(event) => setOrderCustomer(prev => ({ ...prev, customerName: event.target.value }))}
          aria-describedby={`${nameId}-hint`}
        />
        <span id={`${nameId}-hint`} className="text-[11px] text-muted">
          Se mostrará en cocina junto al pedido.
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted" htmlFor={phoneId}>
          Teléfono (opcional)
        </label>
        <input
          id={phoneId}
          type="tel"
          className="input input-bordered"
          placeholder="Ej. 555-1234"
          value={orderCustomer.customerPhone}
          onChange={(event) => setOrderCustomer(prev => ({ ...prev, customerPhone: event.target.value }))}
        />
      </div>
    </div>
  );
}
